import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[loadExamPartResult]',
    standalone: false
})
export class LoadExamPartResultDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
